export default __webpack_public_path__ + "static/media/like-auction-btn.464b40d9.svg";